import React from "react";

import { useDispatch } from "react-redux";

const fetchImproveAreas = (q = "") => (_, __, { api }) => {
  return api
    .get("/private/ideaEffects/improve-areas")
    .then((response) => response.data)
    .catch(() => []);
};

export const useFetchImproveAreas = () => {
  const dispatch = useDispatch();
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    dispatch(fetchImproveAreas())
      .then((data) => setOptions(data))
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, setOptions]);

  return [loading, options];
};
